/* DiagnosticDetectives Timeline Page - Interactions */
(function(){
  function qs(sel, ctx){ return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function openModal(modal){
    if(!modal) return;
    modal.hidden = false;
    // Pause any playing thumb videos when opening
    const vids = modal.querySelectorAll('video');
    vids.forEach(v => { try { v.play(); } catch(e){} });
    const ifr = modal.querySelector('.dd-modal-iframe');
    if (ifr && ifr.dataset && ifr.dataset.embedSrc) {
      // Load embed on open (autoplay handled by URL param)
      ifr.src = ifr.dataset.embedSrc;
    }
    // PDF mobile fallback: add open in new tab link and ensure close button visible
    const pdf = modal.querySelector('.dd-modal-pdf');
    if (pdf) {
      const isMobile = matchMedia('(max-width: 768px)').matches;
      if (isMobile) {
        // Add an "Open in new tab" link once
        if (!modal.querySelector('.dd-pdf-open')) {
          const link = document.createElement('a');
          link.className = 'dd-pdf-open';
          link.textContent = 'Open PDF in new window';
          link.target = '_blank';
          link.rel = 'noopener';
          link.href = pdf.getAttribute('src').replace('#view=FitH','');
          modal.querySelector('.dd-modal-dialog')?.appendChild(link);
        }
      }
    }
    document.documentElement.classList.add('dd-modal-open');
  }
  function closeModal(modal){
    if(!modal) return;
    // Pause videos inside modal
    const vids = modal.querySelectorAll('video');
    vids.forEach(v => { try { v.pause(); } catch(e){} });
    const ifr = modal.querySelector('.dd-modal-iframe');
    if (ifr) {
      // Stop playback by clearing src
      try { ifr.src = ''; } catch(e){}
    }
    modal.hidden = true;
    document.documentElement.classList.remove('dd-modal-open');
  }

  function setupModals(){
    qsa('.dd-open-modal').forEach(btn => {
      const id = btn.getAttribute('data-modal-target');
      const modal = qs('#' + CSS.escape(id));
      if(!modal) return;
      btn.addEventListener('click', () => openModal(modal));
    });
    qsa('.dd-modal').forEach(modal => {
      modal.addEventListener('click', (e) => {
        if(e.target.matches('[data-close], .dd-modal-backdrop')){
          closeModal(modal);
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if(e.key === 'Escape'){
        qsa('.dd-modal').forEach(m => { if(!m.hidden) closeModal(m); });
      }
    });
  }

  function setupAccordions(){
    if (window.__ddAccInit) return; // avoid multiple listeners
    window.__ddAccInit = true;
    // Clear any inline heights/hidden conflicts from prior versions
    qsa('.dd-acc-panel').forEach(p => { p.style.height = ''; });
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.dd-acc-button');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const acc = btn.closest('.dd-accordion');
      const panel = acc && qs('.dd-acc-panel', acc);
      if (!acc || !panel) return;
      const container = acc.closest('.dd-timeline-right') || document;
      // Close siblings immediately
      qsa('.dd-accordion', container).forEach(other => {
        if (other !== acc) {
          const obtn = qs('.dd-acc-button', other);
          const opanel = qs('.dd-acc-panel', other);
          if (obtn && opanel) {
            obtn.setAttribute('aria-expanded','false');
            opanel.hidden = true;
            other.classList.remove('is-open');
          }
        }
      });
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
      acc.classList.toggle('is-open', !expanded);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      setupModals();
      setupAccordions();
    });
  } else {
    setupModals();
    setupAccordions();
  }

  // Re-init when sections load in Theme Editor
  document.addEventListener('shopify:section:load', function(){
    setupModals();
    setupAccordions();
  });
})();
